import React from 'react';
import {
  Avatar,
  Box,
  Card,
  Typography,
  Divider,
  TextField,
  MenuItem,
  Button,
  Grid,
  IconButton
} from '@mui/material';
import { Edit } from '@mui/icons-material';
import { shades } from '../../../../theme.js';
import SideBar from '../../../components/medichat/sidebar.jsx';
import NavBar from '../../global/Navbar.js';
import { useSelector } from 'react-redux';

// Theme imports
import { ThemeProvider, CssBaseline } from '@mui/material';
import customTheme from '../medichatTheme/customTheme.js';

const textFieldStyles = {
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: shades.neutral[400]
    },
    '&:hover fieldset': {
      borderColor: shades.neutral[500]
    },
    '&.Mui-focused fieldset': {
      borderColor: shades.neutral[600]
    }
  },
  '& .MuiInputBase-input': {
    color: shades.neutral[900]
  },
  '& .MuiInputLabel-root': {
    color: 'darkgray'
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: 'black'
  }
};

const ProfileDetails = () => {
  // Pull user data from Redux
  const { user } = useSelector((state) => state.patientAuth) || {};

  // Show loading if user is not yet available
  if (!user) {
    return <div>Loading...</div>;
  }

  return (
    <Box
      sx={{
			  backgroundColor: shades.white[100],
			  flexGrow: 1,
			  p: 2,
			  marginTop: '10vh',
			  overflowY: 'auto',
			  maxHeight: 'calc(100vh - 10vh)',
			  maxWidth: { xs: '100%', sm: '100%', md: 'calc(100vw - 250px)' }
      }}
    >
      <Card
        sx={{
				  mb: 3,
				  backgroundColor: shades.white[100],
				  p: 3,
				  boxShadow: 'none',
				  border: '1px solid #ddd'
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Avatar src={user.avatar} sx={{ width: 100, height: 100, mr: 3 }} />
          <Box>
            <Typography variant='h5' sx={{ color: shades.neutral[700] }}>
              {user.first_name} {user.last_name}
            </Typography>
            <Typography variant='subtitle1' sx={{ color: shades.neutral[600] }}>
              @{user.username}
            </Typography>
          </Box>
        </Box>
      </Card>
      <Card
        sx={{
				  backgroundColor: shades.white[100],
				  p: 3,
				  boxShadow: 'none',
				  border: '1px solid #ddd'
        }}
      >
        <Typography variant='h6' sx={{ color: shades.neutral[700], mb: 2 }}>
          Edit Profile
          <IconButton sx={{ p: 1, m: 0 }}>
            <Edit sx={{ color: shades.neutral[500] }} />
          </IconButton>
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              label='First Name'
              fullWidth
              value={user.first_name}
              sx={textFieldStyles}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label='Last Name'
              fullWidth
              value={user.last_name}
              sx={textFieldStyles}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label='Email'
              fullWidth
              value={user.email}
              sx={textFieldStyles}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label='Phone Number'
              fullWidth
              value={user.phone_number}
              sx={textFieldStyles}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label='Date of Birth'
              fullWidth
              type='date'
              value={user.date_of_birth}
              sx={textFieldStyles}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label='Gender'
              fullWidth
              select
              value={user.gender}
              sx={textFieldStyles}
            >
              <MenuItem value='male'>Male</MenuItem>
              <MenuItem value='female'>Female</MenuItem>
              <MenuItem value='other'>Other</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label='Street'
              fullWidth
              value={user.street}
              sx={textFieldStyles}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label='City'
              fullWidth
              value={user.city}
              sx={textFieldStyles}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label='Postal Code'
              fullWidth
              value={user.postal_code}
              sx={textFieldStyles}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label='Country'
              fullWidth
              value={user.country}
              sx={textFieldStyles}
            />
          </Grid>
        </Grid>
        <Button
          variant='outlined'
          size='small'
          sx={{
					  backgroundColor: 'black',
					  p: 2,
					  mt: 2,
					  color: 'white',
					  '&:hover': {
					    backgroundColor: shades.secondary[400],
					    color: 'white',
					    outline: 'none'
            }
          }}
        >
          Save Changes
        </Button>
      </Card>
    </Box>
  );
};

const ProfilePage = () => {
  return (
    <ThemeProvider theme={customTheme}>
      <CssBaseline />
      <Box sx={{ display: 'flex' }}>
        <NavBar />
        <SideBar />
        <ProfileDetails />
      </Box>
    </ThemeProvider>
  );
};

export default ProfilePage;
